import { FunctionComponent } from 'react';

// Components

// Utilities
import classnames from 'classnames';

// Styles
import styles from './Thanks.module.scss';
import Image from '@Components/Utils/Image';

interface ThanksProps {
    title?: string;
    className?: string;
    subtitle?: string | React.ReactNode;
}

const Thanks: FunctionComponent<ThanksProps> = ({ title, subtitle, className, children }) => {
    const wrapperClassName = classnames([styles.wrapper, className]);

    return (
        <div className={wrapperClassName}>
            <Image className={styles.image_thanks} src="/assets/bottomAction/thanks.png" width={208} height={64} />
            <div className={styles.title}>{title}</div>
            <div className={styles.subtitle}>{subtitle}</div>
            {children}
        </div>
    );
};

Thanks.defaultProps = {
    title: 'Gửi thông tin thành công!',
    className: '',
    subtitle: (
        <>
            Cảm ơn bạn. eDoctor sẽ liên hệ bạn
            <br />
            trong thời gian sớm nhất.
        </>
    ),
};

export default Thanks;
